'use client';

import { useGoogleLogin } from '@react-oauth/google';
import { LogOut, Loader2 } from 'lucide-react';
import { googleLogin } from '@/lib/auth-api';
import { useAuth } from '@/shared/providers/AuthProvider';
import { useI18n } from '@/shared/providers/I18nProvider';

export function AuthButton() {
  const { accessToken, isLoading, setAccessToken, logout } = useAuth();
  const { dict } = useI18n();
  const t = dict.auth;

  const login = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        const { accessToken: token } = await googleLogin(tokenResponse.access_token);
        setAccessToken(token);
      } catch {
        alert(t.loginError);
      }
    },
    onError: () => alert(t.loginErrorTitle),
  });

  if (isLoading) {
    return (
      <div className='rounded-full p-2'>
        <Loader2 className='text-muted-foreground h-5 w-5 animate-spin' />
      </div>
    );
  }

  if (accessToken) {
    return (
      <button
        onClick={logout}
        className='hover:bg-secondary/80 text-muted-foreground hover:text-foreground flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs transition-colors'
        title={t.logoutButton}
        type='button'
      >
        <LogOut className='h-4 w-4' />
        <span>{t.logoutButton}</span>
      </button>
    );
  }

  return (
    <button
      onClick={() => login()}
      className='hover:bg-secondary/80 border-border flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-medium transition-colors'
      type='button'
    >
      <span>{t.loginButton}</span>
      <span className='text-muted-foreground text-[10px]'>{t.loginSubtext}</span>
    </button>
  );
}
